module.exports = __webpack_public_path__ + "assets/acc9c729f0a07f1b2e68dbf536cee2df.png";